import React from "react";

// Mui
import Collapse from "@mui/material/Collapse";
import Fade from "@mui/material/Fade";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import { TransitionGroup } from "react-transition-group";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";

// Navigate
import { useNavigate, useParams } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";

// Fetch

// Config

// Other

// AWS
import OptionCard from "@/components/optionCard";

const LandingFormSettingDetailPage = (props) => {
  const { open, setOpen } = props;
  const { id } = useParams();

  // Navigate
  const navigate = useNavigate();

  // States
  const [onChangeData, setOnChangeData] = React.useState({});
  const [question, setOuestion] = React.useState([]);
  const [slideTranOn, setSlideTranOn] = React.useState(false);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);

  const fetchAll = async () => {};

  const optionOnChange = async (id, type, changeValue, index) => {
    let tempArr = [...question];

    if (type === "deleteQuestion") {
      tempArr.splice(index, 1);
    } else {
      for (let i = 0; i < tempArr.length; i++) {
        if (tempArr[i].id === id) {
          if (type === "type") {
            tempArr[i].type = changeValue;
            tempArr[i].title = "";
            tempArr[i].answer = [];
          }
          if (type === "title") {
            tempArr[i].title = changeValue;
          }
          if (type === "createAnswer") {
            tempArr[i].answer.push("");
          }
          if (type === "answer") {
            tempArr[i].answer[index] = changeValue;
          }
          if (type === "deleteAnswer") {
            tempArr[i].answer.splice(index, 1);
          }
        }
      }
    }
    setOuestion(tempArr);
  };

  const onClickCreate = () => {
    let tempArr = [...question];
    tempArr.push({
      id: tempArr.length > 0 ? tempArr[tempArr.length - 1].id + 1 : 1,
      type: "text",
      title: "",
      answer: [],
    });
    setOuestion(tempArr);
  };

  React.useEffect(() => {
    setSlideTranOn(true);
    // if (id) {
    // fetchAll();
    // } else {
    //   setOnChangeData({
    //     title: "",
    //     brand: "",
    //     product: "",
    //     source: "",
    //     status: "",
    //     bitly3chembio: "",
    //     bitlymannings: "",
    //     bitlyfloating: "",
    //   });
    //   setSlideTranOn(true);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  console.log(question);
  return (
    <Layout
      header="LandingFormSettingDetailPage"
      selectedIndex={14}
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      open={open}
      setOpen={setOpen}
    >
      <Title
        FunctionOn
        createName="新增問題"
        title={`廣告頁表格 / ${id ? "修改廣告頁表格" : "新增廣告頁表格"}`}
        history={() => navigate(-1)}
        onClickCreate={() => onClickCreate()}
      />
      <Fade in={slideTranOn} mountOnEnter unmountOnExit>
        <Grid container spacing={2}>
          <Grid
            size={{
              xs: 8,
              md: 8,
              lg: 8
            }}>
            <TransitionGroup>
              {question.length > 0 &&
                question.map((data, i) => (
                  <Collapse key={i}>
                    <OptionCard
                      index={i}
                      data={data}
                      optionOnChange={optionOnChange}
                    />
                  </Collapse>
                ))}
            </TransitionGroup>
          </Grid>
          <Grid
            size={{
              xs: 4,
              md: 4,
              lg: 4
            }}>
            <StyledPaper page={"yes"}>
              <TextField
                variant="outlined"
                sx={{ width: "100%", marginBottom: "10px" }}
                placeholder={"表格名稱"}
              />
            </StyledPaper>
          </Grid>
        </Grid>
      </Fade>
    </Layout>
  );
};

export default LandingFormSettingDetailPage;
